import type { LocationState } from 'redux-first-router';
import { connect } from 'react-redux';
import DiscoverHub from '@/pages/DiscoverHub';
import type { Props } from '@/pages/DiscoverHub';
import DeprecatedDiscoverHub from '@components/DeprecatedDiscoverHub';
import { useFlag } from '@/features/unleash';

const mapState = (state): Props => {
  const location = state.location as LocationState;
  return {
    route: location.type,
  };
};

type BaseDiscoverHubProps = ReturnType<typeof mapState>;

const BaseDiscoverHub = ({ route }: BaseDiscoverHubProps) => {
  const flag = useFlag({ name: 'mono-discover-hub-redesign' });

  const shouldShowControl =
    flag.flagsReady && flag.enabled && flag.variant.name === 'control';

  if (shouldShowControl) {
    return <DeprecatedDiscoverHub route={route} />;
  }
  return <DiscoverHub route={route} />;
};

export default connect(mapState)(BaseDiscoverHub);
